class afrPostInternalMEO {
  constructor(that) {
    this.that = that
    this.formName = "内部MEO"
    this.that.$('.search_form_wrap').show()
  }

  returnFormName() {
    return this.formName
  }

  getInputData() {
    const $ = this.that.$
    const moment = this.that.moment
    moment.locale("ja")
    const store = this.that.store
    const func = this.that.func

    // 値取得：InternalMEO
    store.commit('setValue', ['internalMeos', 'url', func.textEscape($('#internalMeoURL').val()), 'url'])
    store.commit('setValue', ['internalMeos', 'input_internal_meo_train', $('input[name="internal_meo_train"]:checked').val(), 'input_internal_meo_train'])
  }

  setVal (balanceInfoMsg) {
    const store = this.that.store

    const sendVal = 
`
◎内部MEO
店舗URL：${store.state.formData.internalMeos.url}
写真撮影の有無：${store.state.formData.internalMeos.input_internal_meo_train}
`
    store.commit('setTalknoteMessage', ['internalMeos', sendVal])
  }
}

export default {
  afrPostInternalMEO
}